import { Skeleton, SystemPageLayout } from "@components";
import React, { useEffect } from "react";
import { setPageTitle } from "@common";

function RedirectToSSOPage(): JSX.Element {
    const content = <Skeleton content="Переход на страницу входа в систему" />;

	useEffect(() => {
		setPageTitle('Переход на страницу входа в систему');
	}, []);

    return <SystemPageLayout content={content} />
}

export {RedirectToSSOPage};